import styled from 'styled-components'

export const DropdownListItemTitle = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutralW90};
`

export const DropdownListItemDescription = styled.span`
  font-size: 10px;
  color: ${({ theme }) => theme.colors.neutralW70};
`
